import React from 'react';
import Container from '@material-ui/core/Container';
import Box from '@material-ui/core/Box';

import Copyright from 'components/Copyright';

import useStyles from './PageContainer.style';

const PageContainer: React.FC = ({ children }) => {
  const classes = useStyles();

  return children ? (
    <Container
      disableGutters
      maxWidth={false}
      className={classes.pageContainer}
    >
      {children}
    </Container>
  ) : null;
};

export default PageContainer;

// <Box mt={8}>
// <Copyright />
// </Box>
